import { action, observable, reaction, makeObservable } from 'mobx';
import {contentLoaders, X7PushableBlock, X8Block, X9Content} from '../../../domain';
import {Disposers, HttpPromiseState, Writeable} from '../../../lib/helpers';


function fixNulls(pushableBlock: X7PushableBlock) {
  // prevent nulls
  let writable: Writeable<X7PushableBlock> = pushableBlock;
  if (writable.Blocks === null)
    writable.Blocks = [];
  for (let block of writable.Blocks) {
    let writableBlock: Writeable<X8Block> = block;
    if (writableBlock.Items === null)
      writableBlock.Items = [];
  }
}

export class X7PushableBlockLoader {
  @observable.ref
  state: HttpPromiseState<X7PushableBlock> | null;

  @observable.ref
  pushableBlock: X7PushableBlock | null;
  @observable.ref
  blocks: readonly X8Block[];
  @observable.ref
  blocksById: { [index: number]: X8Block };
  @observable.ref
  contentById: { [index: number]: X9Content };

  private readonly disposers = new Disposers();

  constructor(readonly pushableBlockId: number) {
    makeObservable(this);
    this.state = null;
    this.pushableBlock = null;
    this.blocks = [];
    this.blocksById = {};
    this.contentById = {};
    this.setup();
  }

  @action
  load = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLoaders.x7pushableBlock.get(this.pushableBlockId);
  };

  private setup() {
    this.disposers.add(reaction(
      () => this.state?.state,
      this.onPushableBlockLoaded
    ));
  }

  @action
  private onPushableBlockLoaded = () => {
    this.pushableBlock = null;
    this.blocks = [];
    this.blocksById = {};
    this.contentById = {};

    if (this.state?.isResolved !== true)
      return;

    const pushableBlock = this.state.value;
    fixNulls(pushableBlock);
    this.pushableBlock = pushableBlock;
    this.blocks = pushableBlock.Blocks!;
    for (let block of pushableBlock.Blocks!) {
      this.blocksById[block.Id] = block;
      for (let item of block.Items!)
        this.contentById[item.Id] = item;
    }
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
